var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductVideoPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1094 -2284)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 155,
    transform: "translate(1094 2284)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1111 2365)",
    fill: "#a8a8a8",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.011em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Less than 350MB")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1112 2357)",
    fill: "#5e5873",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.011em",
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MP4 Format")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductVideoPlaceholder);
export default __webpack_public_path__ + "static/media/ProductVideoPlaceholder.dfdfa9d0783cb3086aa138abb66a30e1.svg";
export { ForwardRef as ReactComponent };